import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sb-footer',
  templateUrl: './sb-footer.component.html',
  styleUrls: ['./sb-footer.component.scss']
})
export class SbFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
